import { ITableField } from '@/shared/Tables/Table'
import { IEquipmentEvent } from '../../../equipment.types.ts'
import timeUtils from '../../../../../utils/time.utils.ts'
import equipmentUtils from '../../../equipment.utils.ts'
import Tag from '../../../../../shared/Tags/Tag'

const equipmentEventsTableFields: ITableField<IEquipmentEvent, keyof IEquipmentEvent>[] = [
  {
    key: 'createdAt',
    clientSideOrdering: true,
    width: '100px',
    header: 'Дата',
    getter: (it) => timeUtils.formatDate(new Date(it.createdAt), 'dd MMM yyyy HH:mm:ss'),
    sortGetter: (it) => new Date(it.createdAt).getTime(),
  },
  {
    key: 'type',
    clientSideOrdering: true,
    width: '300px',
    header: 'Событие',
    getter: (it) => {
      switch (it.type) {
        case 'CONNECT':
        case 'DISCONNECT':
          return (
            <Tag color={it.type === 'CONNECT' ? 'green' : 'red'}>
              {equipmentUtils.getEquipmentEventTypeName(it.type)}
            </Tag>
          )
        case 'IN_MAINTENANCE':
          return <Tag color="geekblue">Переведен в обслуживание</Tag>
        case 'FROM_MAINTENANCE_TO_NORMAL':
          return <Tag color="geekblue">Переведен из обслуживания в нормальную работу</Tag>
        case 'LP_ERROR':
          return (
            <Tag color={it.payload.flag === 'WARNING' ? 'orange' : 'red'}>
              {it.payload.errorCode}: {it.payload.errorDescription}
            </Tag>
          )
      }
    },
    sortGetter: (it) => it.type,
  },
]
export default equipmentEventsTableFields
